import {
  ActionIcon,
  Box,
  Button,
  Group,
  Menu,
  Modal,
  Text
} from "@mantine/core";
import React, { useEffect, useMemo, useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";
import { useLanguage } from "../../contexts/language.context";
import { timezones } from "../../utility/util";
import InputField, { InputFieldTypes } from "../input_field";
import { useAgentVariables } from "../../contexts/app.context";
import { SAVE_CALENDAR } from "../../services/calendars";
import { showNotification } from "@mantine/notifications";
import Whatsapps from "../integrations/whatsapp";

export default function ActionForm({ data, setData, extractVariables = [], whatsapps = [], calendars = [], loadWhatsapps, loadCalendars }: any) {
  const { str } = useLanguage();
  const companyVariables = useAgentVariables();
  const v = data;

  const [newCalendar, setNewCalendar] = useState<any>(null);
  const [openWhatsapps, setOpenWhatsapps] = useState<any>(null);

  const actVariables = useMemo(() => [
    ...companyVariables,
    ...(
      data?.when === "after"
        ? extractVariables.map((v: any) => ({
          label: `Extracted Variables - ${v.key}`,
          value: `ExtractedVariables.${v.key}`,
        }))
        : []
    ),
    ...(data?.variables ?? [])
      .filter((v: any) => v.key)
      .map((v: any) => ({ label: `Action.${v.key.toLowerCase()}`, value: `Action.${v.key.toLowerCase()}` }))
  ], [companyVariables, data?.variables, data?.when, extractVariables])

  useEffect(() => {
    if (!data?.timezone && ["schedule_a_call", "book_appointment"].includes(data?.type)) {
      setData((dt: any) => ({ ...dt, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, }));
    }
  }, [data]);

  return <>
    {
      ["call_webhook"].includes(data?.type) && <>
        <InputField
          name="when"
          title={str("AGENTS.WHEN_CALL.TITLE")}
          value={data?.when ?? "during"}
          searchable={false}
          clearable={false}
          mt="md"
          onChange={({ when }) => {
            setData((d: any) => ({ ...d, when }))
          }}
          options={[
            { label: str("AGENTS.WHEN_CALL.DURING"), value: "during" },
            { label: str("AGENTS.WHEN_CALL.BEFORE"), value: "before" },
            { label: str("AGENTS.WHEN_CALL.AFTER"), value: "after" },
          ]}
          fieldType={InputFieldTypes.SELECT}
        />
      </>
    }
    {!["after"].includes(data?.when) && <InputField
      name="description"
      title={!["before"].includes(data?.when) ? str("AGENTS.ACTION_FORM_WHEN_TRIGGER_TITLE") : str("AGENTS.WHEN_CALL.DESCRIPTION_TITLE")}
      placeholder={!["before"].includes(data?.when) ? str("AGENTS.ACTION_FORM_WHEN_TRIGGER_PLACEHOLDER") : str("AGENTS.WHEN_CALL.DESCRIPTION_PLACEHOLDER")}
      value={data?.description}
      fieldType={InputFieldTypes.TEXTAREA}
      min={3}
      max={3}
      mt="md"
      onChange={({ description }) => {
        setData((d: any) => ({ ...d, description }))
      }}
    />}
    {["schedule_a_call"].includes(data?.type) && <>
      {/* <InputField
        name="agent"
        title={str("AGENTS.TITLE")}
        value={data?.agent}
        mt="md"
        onChange={({agent}) => {
          setData((d: any) => ({...d, agent}))
        }}
        options={agents.map(agent => ({
          value: agent.id,
          label: agent.name,
        }))}
        fieldType={InputFieldTypes.SELECT}
      /> */}
      <InputField
        name="timezone"
        title={str("TIMEZONE")}
        value={data?.timezone}
        mt="md"
        onChange={({ timezone }) => {
          setData((d: any) => ({ ...d, timezone }))
        }}
        fieldType={InputFieldTypes.SELECT}
        options={timezones.reduce((pv: any[], tz) => {
          return pv.concat(tz.utc.map(item => ({ value: item, label: `${item}` })))
        }, [])}
      />
    </>}
    {["book_appointment"].includes(data?.type) && <>
      <InputField
        name="calendar"
        title={str("CALENDAR")}
        value={data?.calendar}
        mt="md"
        onChange={({ calendar }) => {
          if (calendar === "new-calendar") setNewCalendar({});
          else setData((d: any) => ({ ...d, calendar }));
        }}
        fieldType={InputFieldTypes.SELECT}
        options={[
          ...calendars.map((c: any) => ({ value: c.id, label: c.title })),
          { value: "new-calendar", label: str("CALENDARS.NEW") },
        ]}
      />
      <InputField
        name="timezone"
        title={str("TIMEZONE")}
        value={data?.timezone}
        mt="md"
        onChange={({ timezone }) => {
          setData((d: any) => ({ ...d, timezone }))
        }}
        fieldType={InputFieldTypes.SELECT}
        options={timezones.reduce((pv: any[], tz) => {
          return pv.concat(tz.utc.map(item => ({ value: item, label: `${item}` })))
        }, [])}
      />
      <InputField
        name="duration"
        title={str("AGENTS.DURATION")}
        value={data?.duration ?? 30}
        mt="md"
        onChange={({ duration }) => {
          setData((d: any) => ({ ...d, duration }))
        }}
        fieldType={InputFieldTypes.NUMBER}
      />
      <InputField
        name="send_email"
        title="Send invitation via e-mail"
        value={data?.send_email ?? true}
        mt="md"
        onChange={({ send_email }) => {
          setData((d: any) => ({ ...d, send_email }))
        }}
        fieldType={InputFieldTypes.CHECKBOX}
      />
    </>}
    {["call_webhook"].includes(data?.type) && <>
      {!["before", "after"].includes(data?.when) && <>
        <Group mt="md">
          <Text fw="bold" style={{ flex: 1 }}>Variables</Text>
          <ActionIcon
            onClick={() => {
              setData((d: any) => ({ ...d, variables: [...(data?.variables ?? []), {}] }))
            }}
          ><FaPlus /></ActionIcon>
        </Group>
        {(v.variables ?? []).map((it: any, ii: number) => <>
          <Group align="flex-end" mt="md">
            <InputField
              name="key"
              title="Variable Key"
              style={{ flex: 0.4 }}
              value={it?.key}
              onChange={({ key }) => {
                setData((d: any) => ({
                  ...d, variables:
                    (data?.variables ?? []).map((it2: any, ij: number) => ii === ij ? { ...it2, key } : it2)
                }))
              }}
            />
            <InputField
              name="description"
              title="Description"
              placeholder={str("AGENTS.VARIABLE_DESCRIPTION_PLACEHOLDER")}
              style={{ flex: 0.6 }}
              value={it?.description}
              onChange={({ description }) => {
                setData((d: any) => ({
                  ...d, variables:
                    (data?.variables ?? []).map((it2: any, ij: number) => ii === ij ? { ...it2, description } : it2)
                }))
              }}
            />
            <ActionIcon size="lg" variant="outline" onClick={() => {
              setData((na: any) => ({ ...na, variables: (data?.variables ?? []).filter((it2: any, ij: number) => ii !== ij) }))
            }}><FaTrash /></ActionIcon>
          </Group>
        </>)}
      </>}

      <Group mt="md">
        {!["after"].includes(data?.when) && <InputField
          name="method"
          title="URL"
          value={data?.method ?? "POST"}
          onChange={({ method }) => { setData((d: any) => ({ ...d, method })) }}
          fieldType={InputFieldTypes.SELECT}
          options={[
            { value: "POST", label: "POST" },
            { value: "GET", label: "GET" },
            { value: "DELETE", label: "DELETE" },
            { value: "PATCH", label: "PATCH" },
            { value: "PUT", label: "PUT" },
          ]}
        />}
        <InputField
          name="url"
          title="URL"
          style={{ flex: 1 }}
          value={data?.url}
          onChange={({ url }) => { setData((d: any) => ({ ...d, url })) }}
        />
      </Group>

      {!["after"].includes(data?.when) && <>

        <InputField
          name="headers"
          title="Headers (json)"
          mt="md"
          fieldType={InputFieldTypes.TEXTAREA}
          value={data?.headers}
          options={actVariables}
          onChange={({ headers }) => { setData((d: any) => ({ ...d, headers })) }}
        />
        <Menu>
          <Menu.Target><Button variant="outline" color="white" mt="xs" size="xs" leftSection={<FaPlus />}>{str("VARIABLE")}</Button></Menu.Target>
          <Menu.Dropdown>
            {
              (actVariables).map(v => (
                <Menu.Item onClick={() => {
                  setData((na: any) => ({ ...na, headers: `${na?.headers ?? ""}{{${v.value}}}` }))
                }}>{v.label}</Menu.Item>
              ))
            }
          </Menu.Dropdown>
        </Menu>
        {data?.method !== "GET" && <>
          <InputField
            name="data"
            title="Body (json)"
            mt="md"
            fieldType={InputFieldTypes.TEXTAREA}
            value={data?.data}
            options={actVariables}
            onChange={({ data }) => { setData((d: any) => ({ ...d, data })) }}
          />
          <Menu>
            <Menu.Target><Button variant="outline" color="white" mt="xs" size="xs" leftSection={<FaPlus />}>{str("VARIABLE")}</Button></Menu.Target>
            <Menu.Dropdown>
              {
                (actVariables).map(v => (
                  <Menu.Item onClick={() => {
                    setData((na: any) => ({ ...na, data: `${na?.data ?? ""}{{${v.value}}}` }))
                  }}>{v.label}</Menu.Item>
                ))
              }
            </Menu.Dropdown>
          </Menu>
        </>}
        {data?.method === "GET" && <>
          <InputField
            name="params"
            title="Params (json)"
            mt="md"
            options={actVariables}
            fieldType={InputFieldTypes.TEXTAREA}
            value={data?.params}
            onChange={({ params }) => { setData((d: any) => ({ ...d, params })) }}
          />
          <Menu>
            <Menu.Target><Button variant="outline" color="white" mt="xs" size="xs" leftSection={<FaPlus />}>{str("VARIABLE")}</Button></Menu.Target>
            <Menu.Dropdown>
              {
                (actVariables).map(v => (
                  <Menu.Item onClick={() => {
                    setData((na: any) => ({ ...na, params: `${na?.params ?? ""}{{${v.value}}}` }))
                  }}>{v.label}</Menu.Item>
                ))
              }
            </Menu.Dropdown>
          </Menu>
        </>}
        <InputField
          name="response_key"
          title="Response Key (the key of the response object to the agent use)"
          mt="md"
          value={data?.response_key ?? "instructions"}
          onChange={({ response_key }) => { setData((d: any) => ({ ...d, response_key })) }}
        />
      </>}
    </>}
    {["integration", "whatsapp"].includes(data?.type) && <>
      <InputField
        name="origin"
        title="Integration Type"
        value={data?.origin}
        fieldType={InputFieldTypes.SELECT}
        clearable={false}
        searchable={false}
        options={[
          { value: "zapier", label: "Zapier Trigger" },
          // { value: "whatsapp", label: "Whatsapp Message" },
          // { value: "wati", label: "Wati Message" },
        ]}
        mt="md"
        onChange={({ origin }) => {
          let variables: any[] = []
          if (origin === "whatsapp") {
            variables = [{ key: "message", blocked: true }]
          }
          setData((d: any) => ({ ...d, origin, variables }))
        }}
      />
      {data?.origin === "whatsapp" && <>
        <InputField
          name="whatsapp_id"
          title="Channel"
          value={data?.whatsapp_id}
          mt="md"
          onChange={({ whatsapp_id }) => {
            setData((d: any) => ({ ...d, whatsapp_id }))
          }}
          fieldType={InputFieldTypes.SELECT}
          options={whatsapps.map((wpp: any) => ({ label: wpp?.data?.phone, value: wpp.id }))}
        />
        <Group justify="flex-end">
          <Button onClick={() => setOpenWhatsapps(true)} size="xs" variant="light">{str("CONNECT")}</Button>
        </Group>
      </>}
      {(data?.origin === "wati") && <>
        <InputField
          name="template_name"
          title="Template Name"
          value={data?.template_name}
          mt="md"
          onChange={({ template_name }) => {
            setData((d: any) => ({ ...d, template_name }))
          }}
        />
        <InputField
          name="api_key"
          title="API KEY"
          value={data?.api_key}
          mt="md"
          onChange={({ api_key }) => {
            setData((d: any) => ({ ...d, api_key }))
          }}
        />
      </>}
      {["zapier", "wati"].includes(data?.origin) && <Group mt="md">
        <Text fw="bold" style={{ flex: 1 }}>{str("VARIABLES")}</Text>
        <ActionIcon
          onClick={() => {
            setData((d: any) => ({
              ...d, variables:
                [...(data?.variables ?? []), {}]
            }))
          }}
        ><FaPlus /></ActionIcon>
      </Group>}
      {(v.variables ?? []).map((it: any, ii: number) => <>
        <Group align="flex-end" mt="md">
          <InputField
            name="key"
            title={str("VARIABLE")}
            style={{ flex: 0.4 }}
            value={it?.key}
            readOnly={it?.blocked}
            onChange={({ key }) => {
              setData((d: any) => ({
                ...d, variables:
                  (data?.variables ?? []).map((it2: any, ij: number) => ii === ij ? { ...it2, key } : it2)
              }))
            }}
          />
          <InputField
            name="description"
            title={str("AGENTS.VARIABLE_DESCRIPTION_TITLE")}
            placeholder={str("AGENTS.VARIABLE_DESCRIPTION_PLACEHOLDER")}
            style={{ flex: 0.6 }}
            value={it?.description}
            onChange={({ description }) => {
              setData((d: any) => ({
                ...d, variables:
                  (data?.variables ?? []).map((it2: any, ij: number) => ii === ij ? { ...it2, description } : it2)
              }))
            }}
          />
          <ActionIcon size="lg" variant="outline" onClick={() => {
            setData((na: any) => ({ ...na, variables: (data?.variables ?? []).filter((it2: any, ij: number) => ii !== ij) }))
          }}><FaTrash /></ActionIcon>
        </Group>
      </>)}
    </>}
    {["transfer_call"].includes(data?.type) && <InputField
      name="phone_number"
      title="Transfer To"
      placeholder="+14412345678"
      mt="md"
      value={data?.phone_number}
      onChange={({ phone_number }) => {
        setData((d: any) => ({ ...d, phone_number }))
      }}
    />}
    {["contact_status", "whatsapp", "integration", "call_webhook", "send_sms"].includes(data?.type) && !["before", "after"].includes(data?.when) && <>
      {/* "The message you will say to callee when calling this tool. Make sure it fits into the conversation smoothly." */}
      <InputField
        mt="sm"
        name="speak_during_execution"
        title={str("AGENTS.SPEAK_DURING_EXECUTION")}
        fieldType={InputFieldTypes.SWITCH}
        value={data?.speak_during_execution}
        onChange={({ speak_during_execution }) => {
          setData((d: any) => ({ ...d, speak_during_execution }))
        }}
      />
      <InputField
        name="execution_message_description"
        placeholder={str("AGENTS.SPEAK_DURING_EXECUTION_DESCRIPTION")}
        mt="xs"
        disabled={!data?.speak_during_execution}
        value={data?.execution_message_description}
        onChange={({ execution_message_description }) => {
          setData((d: any) => ({ ...d, execution_message_description }))
        }}
      />
      <InputField
        mt="sm"
        name="speak_after_execution"
        title={str("AGENTS.SPEAK_AFTER_EXECUTION")}
        fieldType={InputFieldTypes.SWITCH}
        value={data?.speak_after_execution}
        onChange={({ speak_after_execution }) => {
          setData((d: any) => ({ ...d, speak_after_execution }))
        }}
      />
    </>}

    <Modal
      opened={!!newCalendar}
      onClose={() => setNewCalendar(null)}
    >
      <InputField
        name="title"
        placeholder={str("TITLE")}
        value={newCalendar?.title}
        onChange={({ title }) => { setNewCalendar((nc: any) => ({ ...nc, title })) }}
      />
      <Button
        mt="md"
        onClick={() => {
          SAVE_CALENDAR({ ...newCalendar })
            .then(res => {
              setData((d: any) => ({ ...d, calendar: res.id }));
              setNewCalendar(null);
              loadCalendars && loadCalendars();
            })
            .catch(err => {
              showNotification(err);
            })
        }}
      >{str("SAVE")}</Button>
    </Modal>

    <Modal
      opened={!!openWhatsapps}
      onClose={() => {
        setOpenWhatsapps(null)
        loadWhatsapps && loadWhatsapps()
      }}
    >
      {openWhatsapps && <Whatsapps />}
    </Modal>
  </>
}